import { UsersMeResponseDto } from "@/layouts/main/types";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

interface MeState {
  me: UsersMeResponseDto | undefined;
  setMe: (me: UsersMeResponseDto) => void;
}

const useStoreMe = create<MeState>()(
  devtools(
    persist(
      (set) => ({
        me: undefined,
        setMe: (me) => set(() => ({ me })),
      }),
      {
        name: "me", // unique name
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);

export default useStoreMe;
